<template>
    <div class="page main-background">
        <div class="sub-header">
            <h2>{{detail.faTitle}}</h2>
        </div>
        <!-- <div class="sub-header-color colorWhite">
      <div class="dFlex" style="justify-content: flex-start;">
        <router-link :to="{ path: '/car-info/brand/' + brandId}">
          <div class="textCenter" style="width: 50px; ">
            <i class="far fa-arrow-right colorWhite"></i>
          </div>
        </router-link>
        <h2>مشخصات خودرو</h2>
      </div>
    </div> -->
        <div class="text-color card" style="position: relative">
            <div v-if="!loading && detail" class="car-info">
                <div class="tabs">
                    <div class="tab-body">
                        <div class="">

                            <div class="card_padding">
                                <div class="details">
                                    <h1>نام انگلیسی</h1>
                                    <h2 v-if="detail.enTitle">{{ detail.enTitle }}</h2>
                                </div>
                            </div>
                            <hooper :rtl="true" :itemsToShow="1.25" :centerMode="true">
                                <!--slide>
                                    <img class="pic" :src="detail.ImageUrl"/>
                                </slide-->
                                <slide v-for="carImage in detail.carImage" :key="carImage.id" class="car_image">
                                    <img :src="carImage.thumbnailImage" />
                                </slide>
                                <hooper-navigation slot="hooper-addons"></hooper-navigation>
                            </hooper>

                            <div class="card_padding">

                                <div v-if="detail.years" class="summery">
                                    <span>سال تولید:</span>
                                    {{ detail.years }}
                                </div>
                                <div v-if="detail.carStyle" class="summery">
                                    <span>سطح ماشین:</span>
                                    {{ detail.carStyle }}
                                </div>
                                <div v-if="pishraneh1" class="summery">
                                    <span>پیشرانه:</span>
                                    {{ pishraneh1 }}لیتر
                                    {{pishraneh2}}
                                </div>
                                <div v-if="maxPower" class="summery">
                                    <span>حداکثر قدرت:</span>
                                    {{ maxPower }}
                                </div>
                                <div v-if="Transmission" class="summery" style="margin: 20px 0;">
                                    <span class="dBlock">گیربكس:</span>
                                    <h2 class="dBlock textCenter primary-color">{{ Transmission | persian }}</h2>
                                </div>
                                <div v-if="pishraneh3" class="summery" style="margin: 20px 0;">
                                    <span class="dBlock">نوع انتقال قدرت:</span>
                                    <h2 class="dBlock textCenter primary-color">{{ pishraneh3 }}</h2>
                                </div>
                                <p v-html="detail.description"></p>
                                <div class="car-option flex">
                                    <div class="dBlock col-4 textCenter primary-color">
                                        <img src="../../assets/img/carIcon.png" alt="carIcon">
                                        <p class="textCenter">کلاس بدنه: </p>
                                        <p v-if="model1" class="textCenter"> {{ model1 }} </p>
                                    </div>
                                    <div class="dBlock col-4 textCenter primary-color">
                                        <img src="../../assets/img/engineIcon.png" alt="engineIcon">
                                        <p class="textCenter">حجم موتور: </p>
                                        <p v-if="pishraneh1" class="textCenter">{{ pishraneh1 }}</p>
                                    </div>
                                    <div class="dBlock col-4 textCenter primary-color">
                                        <img src="../../assets/img/motorIcon.png" alt="motorIcon">
                                        <p class="textCenter">نوع موتور: </p>
                                        <p v-if="pishraneh2" class="textCenter">{{ pishraneh2 }}</p>
                                    </div>
                                </div>
                                <div class="car-option flex">
                                    <div class="dBlock col-4 textCenter primary-color">
                                        <img src="../../assets/img/cylinderIcon.png" alt="cylinderIcon">
                                        <p class="textCenter">تعداد سوپاپ: </p>
                                        <p v-if="pishraneh4" class="textCenter">{{ pishraneh4 }}</p>
                                    </div>
                                    <div class="dBlock col-4 textCenter primary-color">
                                        <img src="../../assets/img/gearshiftIcon.png" alt="gearshiftIcon">
                                        <p class="textCenter">کلاس خودرو: </p>
                                        <p v-if="model2" class="textCenter"> {{ model2 }} </p>
                                    </div>
                                    <div class="dBlock col-4 textCenter primary-color">
                                        <img src="../../assets/img/petrolIcon.png" alt="petrolIcon">
                                        <p class="textCenter">مصرف سوخت: </p>
                                        <p v-if="getUrbanFuel" class="textCenter">{{ getUrbanFuel }}</p>
                                    </div>
                                </div>

                                <!--div v-if="1"><h3>{{ detail.Categories[0].Title }}</h3></div>
                    <div v-if="1">{{ detail.Categories[0].CarProperties[0].Name }}</div>
                    <div v-if="1">{{ detail.Categories[0].CarProperties[0].Value }}</div>
                    <div v-if="1">{{ detail.Categories[0].CarProperties[1].Name }}</div>
                    <div v-if="1">{{ detail.Categories[0].CarProperties[1].Value }}</div>
                    <div v-if="1">{{ detail.Categories[0].CarProperties[2].Name }}</div>
                    <div v-if="1">{{ detail.Categories[0].CarProperties[2].Value }}</div-->

                                <div v-for="Categories in detail.categories" :key="Categories.id"
                                    class="technical_information">
                                    <h1>{{Categories.title}}</h1>
                                    <div class="technical_information_table">
                                        <div v-for="CategoriesInner in Categories" :key="CategoriesInner.id">
                                            <div v-for="CategoriesInner2 in CategoriesInner" :key="CategoriesInner2.id"
                                                class="technical_information_item">

                                                <span v-if="CategoriesInner2.name" class="technical_information_title">
                                                    {{CategoriesInner2.name}}:
                                                </span>
                                                <span v-if="CategoriesInner2.value">
                                                    {{CategoriesInner2.value}}
                                                </span>

                                            </div>
                                        </div>
                                    </div>

                                </div>

                                <div v-if="getCountry">
                                    <h3>کشور سازنده: {{ getCountry }}</h3>
                                </div>
                                <div v-if="getHoursPower">
                                    <h3>توان: {{ getHoursPower }}</h3>
                                </div>
                                <div v-if="getGearBoxCount">
                                    <h3>گیربکس: {{ getGearBox }} - {{ getGearBoxCount }}</h3>
                                </div>
                                <div v-if="getTopSpeed">
                                    <h3>حداکثر سرعت:</h3>
                                    <h4 class="detail-blue" v-html="getTopSpeed"></h4>
                                </div>
                                <div v-if="getAcceleration">
                                    <h3>شتاب 0 تا 100:</h3>
                                    <h4 class="detail-blue">>{{ getAcceleration }}</h4>
                                </div>
                                <div class="properties">
                                    <div v-if="getBodyType">
                                        <div class="icon">
                                            <img src="../../assets/img/car.png" />
                                        </div>
                                        <div>کلاس بدنه</div>
                                        <div>{{getBodyType}}</div>
                                    </div>
                                    <div v-if="getEngineCapacity">
                                        <div class="icon">
                                            <img src="../../assets/img/engine-2.png" />
                                        </div>
                                        <div>حجم موتور</div>
                                        <div>{{getEngineCapacity}}</div>
                                    </div>
                                    <div v-if="getEngineType">
                                        <div class="icon">
                                            <img src="../../assets/img/motor.png" />
                                        </div>
                                        <div>نوع موتور</div>
                                        <div>{{getEngineType}}</div>
                                    </div>
                                </div>
                                <div class="properties">
                                    <div v-if="getCylinderCount">
                                        <div class="icon">
                                            <img src="../../assets/img/motor-1.png" />
                                        </div>
                                        <div>تعداد سیلندر</div>
                                        <div>{{getCylinderCount}}</div>
                                    </div>
                                    <div v-if="getGearBox">
                                        <div class="icon">
                                            <img src="../../assets/img/gearshift.png" />
                                        </div>
                                        <div>نوع جعبه دنده</div>
                                        <div>{{getGearBox}}</div>
                                    </div>
                                    <div v-if="getFuelConsumption">
                                        <div class="icon">
                                            <img src="../../assets/img/jerrycan.png" />
                                        </div>
                                        <div>مصرف سوخت</div>
                                        <div>{{getFuelConsumption}}</div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div ref="countriesBody"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions } from "vuex";
import api from "../../service";

import {
    Hooper,
    Slide,
    Navigation as HooperNavigation
} from 'hooper';

import 'hooper/dist/hooper.css';

export default {
    name: "car-info-detail",
    props: {
        carId: {
            type: String,
            required: true,
        },
    },
    components: {
        Hooper,
        Slide,
        HooperNavigation
    },
    data() {
        return {
            loading: true,
            detail: {},
            brandId: ''
        };
    },
    computed: {
        maxPower: function () {
            if (this.detail && this.detail.categories) {
                const carCategory = this.detail.categories.filter(cat => cat.title.trim() == "پیشرانه")[0];
                if (carCategory) {
                    const carProperties = carCategory.carProperties.filter(pro => pro.name.trim() == "حداکثر قدرت")[0];
                    if (carProperties)
                        return carProperties.value;
                }
            }
            return null;
        },
        pishraneh1: function () {
            if (this.detail && this.detail.categories) {
                const carCategory = this.detail.categories.filter(cat => cat.title.trim() == "پیشرانه")[0];
                if (carCategory) {
                    const carProperties = carCategory.carProperties.filter(pro => pro.name.trim() == "حجم موتور")[0];
                    if (carProperties)
                        return carProperties.value;
                }
            }
            return null;
        },
        pishraneh2: function () {
            if (this.detail && this.detail.categories) {
                const carCategory = this.detail.categories.filter(cat => cat.title.trim() == "پیشرانه")[0];
                if (carCategory) {
                    const carProperties = carCategory.carProperties.filter(pro => pro.name.trim() == "نوع موتور")[0];
                    if (carProperties)
                        return carProperties.value;
                }
            }
            return null;
        },
        pishraneh3: function () {
            if (this.detail && this.detail.categories) {
                const carCategory = this.detail.categories.filter(cat => cat.title.trim() == "پیشرانه")[0];
                if (carCategory) {
                    const carProperties = carCategory.carProperties.filter(pro => pro.name.trim() == "نوع انتقال قدرت")[0];
                    if (carProperties)
                        return carProperties.value;
                }
            }
            return null;
        },
        pishraneh4: function () { //سوپاپ
            if (this.detail && this.detail.categories) {
                const carCategory = this.detail.categories.filter(cat => cat.title.trim() == "پیشرانه")[0];
                if (carCategory) {
                    const carProperties = carCategory.carProperties.filter(pro => pro.name.trim() == "سوپاپ")[0];
                    if (carProperties)
                        return carProperties.value;
                }
            }
            return null;
        },
        Transmission: function () {
            if (this.detail && this.detail.categories) {
                const carCategory = this.detail.categories.filter(cat => cat.title.trim() == "پیشرانه")[0];
                if (carCategory) {
                    const carProperties = carCategory.carProperties.filter(pro => pro.name.trim() == "گیربكس")[0];
                    if (carProperties)
                        return carProperties.value;
                }
            }
            return null;
        },

        getCountry: function () {
            if (this.detail && this.detail.categories) {
                const carCategory = this.detail.categories.filter(cat => cat.title.trim() == "مشخصات تولید کننده")[0];
                if (carCategory) {
                    const carProperties = carCategory.carProperties.filter(pro => pro.name.trim() == "مشخصات تولید کننده")[0];
                    if (carProperties)
                        return carProperties.value;
                }
            }
            return null;
        },
        getHoursPower: function () {
            if (this.detail && this.detail.categories) {
                const carCategory = this.detail.categories.filter(cat => cat.title.trim() == "مشخصات فنی موتور")[0];
                if (carCategory) {
                    const carProperties = carCategory.carProperties.filter(pro => pro.name.trim() == "حداکثر توان خروجی (دور بر دقیقه / اسب بخار)")[0];
                    if (carProperties)
                        return carProperties.value;
                }
            }
            return null;
        },
        getGearBox: function () {
            if (this.detail && this.detail.categories) {
                const carCategory = this.detail.categories.filter(cat => cat.title.trim() == "مشخصات جعبه دنده")[0];
                if (carCategory) {
                    const carProperties = carCategory.carProperties.filter(pro => pro.name.trim() == "نوع جعبه دنده")[0];
                    if (carProperties)
                        return carProperties.value;
                }
            }
            return null;
        },
        getGearBoxCount: function () {
            if (this.detail && this.detail.categories) {
                const carCategory = this.detail.categories.filter(cat => cat.title.trim() == "مشخصات جعبه دنده")[0];
                if (carCategory) {
                    const carProperties = carCategory.carProperties.filter(pro => pro.name.trim() == "تعداد دنده (جلو)")[0];
                    if (carProperties)
                        return carProperties.value + " دنده";
                }
            }
            return null;
        },
        getTopSpeed: function () {
            if (this.detail && this.detail.categories) {
                const carCategory = this.detail.categories.filter(cat => cat.title.trim() == "عملکرد اتومبیل")[0];
                if (carCategory) {
                    const carProperties = carCategory.carProperties.filter(pro => pro.name.trim() == "حداکثر سرعت")[0];
                    if (carProperties)
                        return carProperties.value.replace("کیلومتر بر ساعت", "<span style='font-size: 18px;'>KM/H</span>");
                }
            }
            return null;
        },
        getAcceleration: function () {
            if (this.detail && this.detail.categories) {
                const carCategory = this.detail.categories.filter(cat => cat.title.trim() == "عملکرد اتومبیل")[0];
                if (carCategory) {
                    const carProperties = carCategory.carProperties.filter(pro => pro.name.trim() == "شتاب 0 الی 100")[0];
                    if (carProperties)
                        return carProperties.value.replace("ثانیه", "s");
                }
            }
            return null;
        },
        getBodyType: function () { // نوع بدنه
            if (this.detail && this.detail.categories) {
                const carCategory = this.detail.categories.filter(cat => cat.title.trim() == "مشخصات فنی بدنه")[0];
                if (carCategory) {
                    const carProperties = carCategory.carProperties.filter(pro => pro.name.trim() == "کلاس بدنه")[0];
                    if (carProperties)
                        return carProperties.value;
                }
            }
            return null;
        },
        getEngineCapacity: function () { // حجم موتور
            if (this.detail && this.detail.categories) {
                const carCategory = this.detail.categories.filter(cat => cat.title.trim() == "مشخصات فنی موتور")[0];
                if (carCategory) {
                    const carProperties = carCategory.carProperties.filter(pro => pro.name.trim() == "حجم موتور")[0];
                    if (carProperties)
                        return carProperties.value;
                }
            }
            return null;
        },
        getEngineType: function () { // نوع موتور
            if (this.detail && this.detail.categories) {
                const carCategory = this.detail.categories.filter(cat => cat.title.trim() == "مشخصات فنی موتور")[0];
                if (carCategory) {
                    const carProperties = carCategory.carProperties.filter(pro => pro.name.trim() == "نوع موتور")[0];
                    if (carProperties)
                        return carProperties.value;
                }
            }
            return null;
        },
        getCylinderCount: function () { // تعداد سیلندر
            if (this.detail && this.detail.categories) {
                const carCategory = this.detail.categories.filter(cat => cat.title.trim() == "مشخصات فنی موتور")[0];
                if (carCategory) {
                    const carProperties = carCategory.carProperties.filter(pro => pro.name.trim() == "تعداد سیلندرها")[0];
                    if (carProperties)
                        return carProperties.value;
                }
            }
            return null;
        },
        getFuelConsumption: function () { // مصرف سوخت
            if (this.detail && this.detail.categories) {
                const carCategory = this.detail.categories.filter(cat => cat.title.trim() == "عملکرد اتومبیل")[0];
                if (carCategory) {
                    const carProperties = carCategory.carProperties.filter(pro => pro.name.trim() == "مصرف سوخت شهری")[0];
                    if (carProperties)
                        return carProperties.value;
                }
            }
            return null;
        },
        model1: function () { // کلاس بدنه
            if (this.detail && this.detail.categories) {
                const carCategory = this.detail.categories.filter(cat => cat.title.trim() == "مدل")[0];
                if (carCategory) {
                    const carProperties = carCategory.carProperties.filter(pro => pro.name.trim() == "کلاس بدنه")[0];
                    if (carProperties)
                        return carProperties.value;
                }
            }
            return null;
        },
        model2: function () { // کلاس خودرو
            if (this.detail && this.detail.categories) {
                const carCategory = this.detail.categories.filter(cat => cat.title.trim() == "مدل")[0];
                if (carCategory) {
                    const carProperties = carCategory.carProperties.filter(pro => pro.name.trim() == "کلاس خودرو")[0];
                    if (carProperties)
                        return carProperties.value;
                }
            }
            return null;
        },
        getUrbanFuel: function () {// مصرف سوخت در شهر
            if (this.detail && this.detail.categories) {
                const carCategory = this.detail.categories.filter(cat => cat.title.trim() == "سوخت")[0];
                if (carCategory) {
                    const carProperties = carCategory.carProperties.filter(pro => pro.name.trim() == "مصرف سوخت در شهر")[0];
                    if (carProperties) {
                        return carProperties.value;
                    }
                }
            }
            return null;
        }
    },
    mounted: function () {
        this.loading = true;
        api.getCarPropertiesByCarId(this.carId).then((response) => {
            this.loading = false;
            if (response.data && response.data.status === 200) {
                this.detail = response.data.data;
                //console.log(JSON.parse(JSON.stringify(this.detail)));
                this.brandId = JSON.parse(JSON.stringify(this.detail.brandId));
            }
        });
    },
    methods: {
        ...mapActions(["setTheme", "setToken"])
    },
};
</script>
<style scoped>
.card {
    border: solid 1px;
    margin: 10px 10px 0 10px;
    border-radius: 5px;
    padding: 15px 7px;
    display: flex;
    flex-direction: column;
    border-bottom: solid 3px #09389f !important;
    position: relative;
}

.card {
    padding: 10px;
}

.dark .card {
    background: #393939;
}

.car-info {
    display: flex;
}

.tabs {
    display: flex;
    max-width: 100%;
    flex: 1;
    flex-direction: column;
}

.tabs>.tab-header {
    display: flex;
    flex-direction: row;
    height: 42px;
    align-items: center;
}

.tabs>.tab-header>div {
    padding: 0 15px;
    line-height: 42px;
    height: 42px;
}

.tabs>.tab-header>div.active {
    background-color: #09389f;
    color: #fff;
}

.brand-item {
    position: relative;
    padding: 10px;
}

.brand-item img.logo {
    position: absolute;
    top: 20px;
    left: 20px;
    width: 80px;
    height: 80px;
    z-index: 2;
}

.brand-item img.pic {
    position: relative;
    width: 100%;
    min-height: 220px;
    margin-bottom: 10px;
    ;
}

.brand-item h3 {
    font-size: 1.2em;
    line-height: 40px;
}

.brand-item div.details {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    text-align: right;
    align-items: center;
}

.brand-item p {
    text-align: justify;
    margin-top: 16px;
}

.detail-blue {
    font-size: 1.8rem !important;
    text-align: center;
    color: #09389f;
    direction: ltr;
}

.properties {
    display: flex;
    justify-content: space-around;
}

.properties div.icon {
    background-color: #09389f;
    width: 80px;
    height: 80px;
    display: inline-block;
    border-radius: 10px;
    margin-top: 15px;
    padding: 12px;
}

.properties div.icon img {
    width: 100%;
}

.properties>div {
    text-align: center;
    color: #09389f;
    font-size: 14px;
    font-weight: bold;
    flex: 1;
    line-height: 25px;
}

.hooper {
    height: auto;
    margin: 0 0 10px;
}

.card {
    border: none;
    background: #fff;
    padding: 0;
    border-radius: 5px;
    box-shadow: 0 0px 5px #8686866b;
}

.card_padding {
    padding: 0 20px;
    color: #646464;
    text-align: justify;
    font-size: 14px;
    line-height: 24px;
}

.dark .card_padding {
    color: #959595;
}

.car_image {
    padding: 0 5px;
}

.car_image img {
    width: 100%;
    height: auto;
    border-radius: 15px;
    box-shadow: 0 0px 5px #8686866b;
}

.details h1 {
    color: #646464;
    font-weight: normal;
    margin: 15px 0 0 0;
    font-size: 18px;
}

.details h2 {
    color: #646464;
    font-weight: normal;
    margin: 0 0 15px;
    font-size: 18px;
}

.dark .details h1,
.dark .details h2 {
    color: #b9b9b9;
}

.summery {
    font-size: 16px;
    margin: 0 0 8px;
}

.summery span {
    color: #000;
}

.dark .summery span {
    color: #b9b9b9;
}

.technical_information {
    margin: 10px 0 0 0;
}

.technical_information h1 {
    background: #304ad2;
    color: #fff;
    font-size: 16px;
    font-weight: normal;
    padding: 8px 10px;
    border-radius: 10px;
}

.technical_information_table {
    background: #e1e1e1;
    margin: 10px 0;
    border-radius: 10px;
    font-size: 12px;
}

.technical_information_item {
    padding: 0 10px;
}

.technical_information_item:nth-child(even) {
    background: #ebebeb;
}

.technical_information_item:last-child {
    border-radius: 0 0 10px 10px;
}

.technical_information_title {
    color: #000;
}

.car-option img {
    background: #002664;
    padding: 15px 10px;
    border-radius: 5px;
    margin: 10px 10px 0px;
}
</style>